var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("data-title", { attrs: { list: _vm.workEmailData } }),
          _c(
            "div",
            { staticClass: "forms" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "search-form",
                  attrs: {
                    inline: true,
                    model: _vm.form,
                    size: "small",
                    "label-width": "64px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "工作邮箱" } },
                    [
                      _c("el-input", {
                        staticClass: "inline-input",
                        attrs: { placeholder: "请输入内容", clearable: "" },
                        model: {
                          value: _vm.form.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "account", $$v)
                          },
                          expression: "form.account",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "最后归属人" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "custom-label" }, [
                                _vm._v("最后"),
                                _c("br"),
                                _vm._v("归属人"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-autocomplete", {
                        staticClass: "inline-input",
                        attrs: {
                          "fetch-suggestions": _vm.userSearch,
                          placeholder: "请输入内容",
                          "trigger-on-focus": false,
                          clearable: "",
                        },
                        on: { select: _vm.userSelect },
                        model: {
                          value: _vm.form.ownerUserName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ownerUserName", $$v)
                          },
                          expression: "form.ownerUserName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "最后归属部门" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "custom-label" }, [
                                _vm._v("最后"),
                                _c("br"),
                                _vm._v("归属部门"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          "show-all-levels": false,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgPath",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleSelectOrgId },
                        model: {
                          value: _vm.form.orgId1,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orgId1", $$v)
                          },
                          expression: "form.orgId1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间" } },
                    [
                      _c("eldate", {
                        attrs: { dateData: _vm.createdTime },
                        on: {
                          changeData: function ($event) {
                            return _vm.changeData($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "归属人是否离职" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "custom-label" }, [
                                _vm._v("归属人"),
                                _c("br"),
                                _vm._v("是否离职"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.form.ownerUserStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "ownerUserStatus", $$v)
                            },
                            expression: "form.ownerUserStatus",
                          },
                        },
                        _vm._l(_vm.ownerUserStatusList, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审批状态" } },
                    [
                      _vm.dictionaries.property_act_status
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.form.actStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "actStatus", $$v)
                                },
                                expression: "form.actStatus",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.property_act_status,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮箱状态" } },
                    [
                      _vm.dictionaries.property_phone_status
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.form.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.property_phone_status,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮箱备注" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新时间" } },
                    [
                      _c("eldate", {
                        attrs: { dateData: _vm.updatedTime },
                        on: {
                          changeData: function ($event) {
                            return _vm.changeUpdatedData($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "s-btn",
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "r-btn",
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "line" }),
              _c("div", { staticClass: "data-title" }, [
                _vm._m(0),
                _c("div", { staticClass: "title-btn" }, [
                  _vm.parArray.includes("email_export")
                    ? _c(
                        "div",
                        {
                          staticClass: "title-btn-item",
                          staticStyle: { "margin-right": "12px" },
                          on: {
                            click: function ($event) {
                              return _vm.deliverData()
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "16px", height: "16px" },
                            attrs: {
                              src: require("@/assets/img/assetManagement/icon_daochu.png"),
                            },
                          }),
                          _c("div", { staticClass: "btn-l" }, [
                            _vm._v("导出列表"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.parArray.includes("email_transfer")
                    ? _c(
                        "div",
                        {
                          staticClass: "title-btn-item",
                          staticStyle: { "margin-right": "12px" },
                          on: {
                            click: function ($event) {
                              return _vm.transferData()
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "16px", height: "16px" },
                            attrs: {
                              src: require("@/assets/img/assetManagement/icon_dayin.png"),
                            },
                          }),
                          _c("div", { staticClass: "btn-l" }, [
                            _vm._v("批量转移"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "title-btn-item", on: { click: _vm.add } },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("div", { staticClass: "btn-l" }, [
                        _vm._v("新增工作邮箱"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c("lb-table", {
                directives: [
                  {
                    name: "horizontal-scroll",
                    rawName: "v-horizontal-scroll",
                    value: "always",
                    expression: "'always'",
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  column: _vm.columns,
                  data: _vm.list,
                  pagination: "",
                  total: _vm.totalNum,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50, 200, 2000],
                  "current-page": _vm.page.pageNo,
                  "page-size": _vm.page.pageSize,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "pageNo", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "pageNo", $event)
                  },
                  "selection-change": _vm.onMultipleSelection,
                  "size-change": _vm.handleSizeChange,
                  "p-current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "转移", multiple: false },
        on: { ok: _vm.selected },
      }),
      _c("pop-report", {
        ref: "popReport",
        attrs: { btnTransfer: _vm.btnTransfer, reportList: _vm.reportList },
      }),
      _c("pop-cancel", {
        ref: "popCancel",
        attrs: { title: "是否确认注销该工作邮箱？" },
        on: { setCancel: _vm.setCancel },
      }),
      _c("pop-revoke", {
        ref: "popRevoke",
        attrs: { title: "是否确认撤销该工作邮箱？" },
        on: { setRevoke: _vm.setRevoke },
      }),
      _c("pop-delete", {
        ref: "popDelete",
        attrs: { title: "是否确认删除？" },
        on: { setDelete: _vm.setDelete },
      }),
      _c("pop-Remark", { ref: "popRemark", on: { setRemark: _vm.setRemark } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("数据列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }